<template>
  <ListDonations  ref="listDonations" v-if="currentState === 'listDonations'"/>
</template>

<script>
import ListDonations from './ListDonations';
export default {
  name: 'DonationsManager',
  components: { ListDonations },
  data: () => ({
    currentState: 'listDonations'
  })
};
</script>
